module.exports = __webpack_public_path__ + "static/media/azure.da8c3291.png";